import { Record } from 'immutable';
import { isValidAvatarImageType } from 'MeetingsBase/utils/imageValidation';
export const defaults = {
  body: '',
  subject: '',
  title: '',
  avatarUrl: '',
  avatarOption: 'PROFILE_IMAGE'
};
export default class CustomConfirmationEmail extends Record(defaults) {
  static from(json) {
    return new CustomConfirmationEmail(json);
  }
  static equalsJSON(first, second) {
    return JSON.stringify(first) === JSON.stringify(second);
  }
  static validator(current, unedited) {
    const currentBody = current.get('body');
    const currentSubject = current.get('subject');
    const currentTitle = current.get('title');
    const currentAvatarUrl = current.get('avatarUrl');
    const currentAvatarOption = current.get('avatarOption');
    const uneditedBody = unedited.get('body');
    const uneditedSubject = unedited.get('subject');
    const uneditedTitle = unedited.get('title');
    if (!uneditedBody && !uneditedSubject && !uneditedTitle) return null;
    if (!currentBody || !currentSubject || !currentTitle) return 'editLink.reminder.customize.validationBodySubjectAndTitle';
    if (currentSubject.length > 200) return 'editLink.reminder.customize.validationSubjectTooLong';
    if (currentTitle.length > 200) return 'editLink.reminder.customize.validationTitleTooLong';
    if (currentAvatarOption === 'CUSTOM_AVATAR' && currentAvatarUrl) {
      if (!isValidAvatarImageType(currentAvatarUrl)) {
        return 'editLink.reminder.customize.validationAvatarInvalidType';
      }
    }
    return null;
  }
  equals(other) {
    const firstJson = this.toJSON();
    const secondJson = other.toJSON();
    return CustomConfirmationEmail.equalsJSON(firstJson, secondJson);
  }

  /**
   * Use toJSON
   * @deprecated
   */
  toJS() {
    return super.toJS();
  }
}